import {
  GET_MAINTENANCE_RECORDS_REQUEST,
  GET_MAINTENANCE_RECORDS_SUCCESS,
  GET_MAINTENANCE_RECORDS_ERROR,
  GET_MAINTENANCE_RECORD_REQUEST,
  GET_MAINTENANCE_RECORD_SUCCESS,
  GET_MAINTENANCE_RECORD_ERROR,
  GET_REPAIR_DETAILS_REQUEST,
  GET_REPAIR_DETAILS_SUCCESS,
  GET_REPAIR_DETAILS_ERROR,
  CREATE_REPAIR_RECORD_REQUEST,
  CREATE_REPAIR_RECORD_SUCCESS,
  CREATE_REPAIR_RECORD_ERROR,
  CREATE_MAINTENANCE_RECORD_REQUEST,
  CREATE_MAINTENANCE_RECORD_SUCCESS,
  CREATE_MAINTENANCE_RECORD_ERROR,
  UPLOAD_ASSET_REQUEST,
  UPLOAD_ASSET_SUCCESS,
  UPLOAD_ASSET_ERROR,
  UPDATE_MAINTENANCE_RECORD_REQUEST,
  UPDATE_MAINTENANCE_RECORD_SUCCESS,
  UPDATE_MAINTENANCE_RECORD_ERROR,
  DELETE_ASSET_REQUEST,
  DELETE_ASSET_SUCCESS,
  DELETE_ASSET_ERROR,
} from './maintenanceActionTypes';

const initialState = {
  isLoading: false,
  isUploading: false,
  isSuccess: false,
  payload: {},
  message: '',
  maintenanceRecords: [],
  maintenanceRecord: {},
  maintenanceRepairs: [],
  maintenanceStatistics: {},
  pagination: {},
  itemsCount: 0,
};

export default function maintenanceReducer(state = initialState, action) {
  const { type, payload, isLoading, isUploading, isSuccess, message } = action;

  switch (type) {
    case GET_MAINTENANCE_RECORDS_REQUEST:
      return { ...state, isLoading };
    case GET_MAINTENANCE_RECORDS_SUCCESS:
      return {
        ...state,
        isLoading,
        maintenanceRecords: payload.data,
        maintenanceStatistics: payload.statistics,
        pagination: payload,
      };
    case GET_MAINTENANCE_RECORDS_ERROR:
      return { ...state, isLoading, message };
    case GET_MAINTENANCE_RECORD_REQUEST:
      return { ...state, isLoading };
    case GET_MAINTENANCE_RECORD_SUCCESS:
      return { ...state, isLoading, maintenanceRecord: payload.data };
    case GET_MAINTENANCE_RECORD_ERROR:
      return { ...state, isLoading, message };
    case GET_REPAIR_DETAILS_REQUEST:
      return { ...state, isLoading, isSuccess };
    case GET_REPAIR_DETAILS_SUCCESS:
      return { ...state, isLoading, isSuccess, maintenanceRepairs: payload.data, itemsCount: payload.count };
    case GET_REPAIR_DETAILS_ERROR:
      return { ...state, isLoading, isSuccess, message };
    case CREATE_MAINTENANCE_RECORD_REQUEST:
      return { ...state, isLoading, isSuccess };
    case CREATE_MAINTENANCE_RECORD_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case CREATE_MAINTENANCE_RECORD_ERROR:
      return { ...state, isLoading, isSuccess, message };
    case CREATE_REPAIR_RECORD_REQUEST:
      return { ...state, isLoading, isSuccess };
    case CREATE_REPAIR_RECORD_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case CREATE_REPAIR_RECORD_ERROR:
      return { ...state, isLoading, isSuccess, message };
    case UPLOAD_ASSET_REQUEST:
      return { ...state, isLoading, isUploading, isSuccess };
    case UPLOAD_ASSET_SUCCESS:
      return { ...state, isLoading, isUploading, isSuccess, message };
    case UPLOAD_ASSET_ERROR:
      return { ...state, isLoading, isUploading, message };
    case UPDATE_MAINTENANCE_RECORD_REQUEST:
      return { ...state, isLoading, isSuccess };
    case UPDATE_MAINTENANCE_RECORD_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case UPDATE_MAINTENANCE_RECORD_ERROR:
      return { ...state, isLoading, isSuccess, message };
    case DELETE_ASSET_REQUEST:
      return { ...state, isLoading, isSuccess };
    case DELETE_ASSET_SUCCESS:
      return { ...state, isLoading, isSuccess, message };
    case DELETE_ASSET_ERROR:
      return { ...state, isLoading, isSuccess, message };
    default: {
      return state;
    }
  }
}
